import React from 'react';
import { ShieldCheck, Lock, Zap, FileText } from 'lucide-react';

const items = [
  { Icon: ShieldCheck, iconBg: 'bg-emerald-50', iconColor: 'text-emerald-600', title: 'Compatible con Hacienda', subtitle: 'API oficial DTE El Salvador' },
  { Icon: Lock,        iconBg: 'bg-indigo-50',  iconColor: 'text-brand-600',  title: 'Firma .p12 segura',       subtitle: 'Almacenamiento cifrado' },
  { Icon: Zap,         iconBg: 'bg-amber-50',   iconColor: 'text-amber-600',  title: 'Modo contingencia',       subtitle: 'Facturás aunque Hacienda falle' },
  { Icon: FileText,    iconBg: 'bg-cyan-50',    iconColor: 'text-cyan-600',   title: '11 tipos de DTE',         subtitle: 'Factura, CCF, NC, ND, NR…' },
];

export default function TrustStrip() {
  return (
    <section className="border-y border-ink-100 bg-white">
      <div className="max-w-6xl mx-auto px-6 py-5 grid grid-cols-2 md:grid-cols-4 gap-4">
        {items.map(({ Icon, iconBg, iconColor, title, subtitle }) => (
          <div key={title} className="flex items-center gap-3 justify-center md:justify-start">
            <div className={`w-9 h-9 rounded-lg ${iconBg} flex items-center justify-center flex-shrink-0`}>
              <Icon size={16} strokeWidth={2.4} className={iconColor} />
            </div>
            <div className="text-[13px]">
              <div className="font-semibold text-ink-900">{title}</div>
              <div className="text-ink-500">{subtitle}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
